import { useState } from "react"
import { AICALocationsOptions, gdqStatusOptions } from "../../../../lib/systemData"
import CustomSelect from "../../../common/interactive/CustomSelect"
import InputBox from "../../../common/interactive/InputBox"
import RangeDatePickerFilter from "./filters/RangeDatePickerFilter"
import Button from "../../../common/Button"
import { useDispatch } from "react-redux"
import { filterActions } from "../../../../store/filter"
import { workqueueActions } from "../../../../store/workqueue"
import { setFiltersInLocalStorage } from "../../../../lib/filters"
import { removeStorageItem } from "../../../../lib/script"


export default function GDQWorkQFilters({workQ}) {
    const dispatch = useDispatch()
    const [filtersValues, setFiltersValues] = useState(null)

    function mainSelectAction(value) {
        let updateobject = {
            ...filtersValues
        }     
        let update = JSON.parse(JSON.stringify(updateobject))

        //need to expand the object and include name of the selected options!
        if (value?.data?.value?.constructor == Array) { // check if array
            
            update[value.identifier.type] = value.data.value

        } else {
            update[value.identifier.type] = value.data.value

            if (value.identifier.type == 'do_not_lien') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            if (value.identifier.type == 'ihc_review') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            
        }

        if (value.identifier.type == 'payer_type') { // if it is payer_type reset the payer status!!!!
            update.payer_status = null
        }

        setFiltersValues(update)
    }

    // function mainSelectAction(value) {
    //     let update = {
    //         ...filtersValues
    //     }

    //     // update[value.identifier.type]= value.data.value
    //     //need to expand the object and include name of the selected options!
    //     if (value.data.value.constructor == Array) { // check if array
            
    //         // update[value.identifier.type] = value.data.value

    //         update[value.identifier.type] = value.options
    //     } else {
    //         update[value.identifier.type]= {
    //             value: value.data.value,
    //             item: value.option
    //         }
    //     }



    //     setFiltersValues(update)


    // }

    
    // form apply filters
    async function setFiltersHandler() {
        dispatch(filterActions.setFiltersMultiple(filtersValues))
        dispatch(workqueueActions.setRefreshApi()) //filters do not refresh the api anymore!!!1
        
        //add the filters in local storage for persistent filtering after refresh
        setFiltersInLocalStorage(filtersValues, workQ?.slug)

    }

    function clearAllFiltersHandler() {
        dispatch(filterActions.setFiltersMultiple({}))
        dispatch(workqueueActions.setRefreshApi()) //filters do not refresh the api anymore!!!1

        setFiltersValues(null)
        // remove the local storage if any 
        removeStorageItem(workQ?.slug)

    }


    return <>
        {/* date range picker  */}
        <RangeDatePickerFilter />
        {/* search  */}
        <InputBox label={'Search'} setStyle={'bk_white'} action={mainSelectAction} name={'search'} identifier={{type: 'search'}}/>

        {/* gdq_status  */}
        <CustomSelect label={"GDQ Status"} optionsData={gdqStatusOptions().filter(item => item.is_gdq)} preSelectedValue={filtersValues?.gdq_status_id} action={mainSelectAction} name={'gdq_status_id'} identifier={{type: 'gdq_status_id'}}/>

        {/* aica_location  */}        
        <CustomSelect label={"Location"} optionsData={AICALocationsOptions()} preSelectedValue={filtersValues?.location} action={mainSelectAction} name={'location'} identifier={{type: 'location'}}/>
        <Button click={clearAllFiltersHandler} btnStyle={'btn_white'}>Clear All Filters</Button>
        <Button click={setFiltersHandler}>Set Filters</Button>
    </>
}